<template slot="navbar">
  <b-navbar
    id="header-navbar"
    toggleable="md"
    fixed="top"
    class="bg-white shadow-lg"
  >
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-navbar-brand class="vitalliance-icon" to="/home">
      <svgicon
        icon="va"
        color="var(--primary) #f6a000 #c7cf00 #ec5f71 #c7cf00 #f6a000 #44bdd2 #ec5f71 #44bdd2"
        width="175"
        height="28"
      ></svgicon>
    </b-navbar-brand>

    <b-navbar-brand
      class="discussion-icon"
      v-if="isShowChat"
      style="margin-left:15px; position:relative"
      to="/discussions"
    >
      <svgicon
        icon="chat"
        width="25"
        height="25"
        color="var(--primary)"
        class="mr-1"
        style="vertical-align: middle"
      />
      <div
        class="num"
        v-if="numberUnreadConversations && numberUnreadConversations > 0"
      >
        {{ numberUnreadConversations }}
      </div>
    </b-navbar-brand>

    <b-navbar-brand
      v-if="showNotification"
      class="noti-icon"
      style="position:relative;margin-left:10px;"
      to="/notifications"
    >
      <div class="position-relative">
        <svgicon
          icon="envelope"
          width="25"
          height="25"
          color="var(--primary)"
          class="mr-1"
          style="vertical-align: middle"
        />
        <div
          v-if="numberNotiInApp && numberNotiInApp > 0"
          class="unread-number position-absolute"
        >
          {{ numberNotiInApp }}
        </div>
      </div>
    </b-navbar-brand>
    <b-collapse is-nav id="nav_collapse" class="bg-white c-main-nav">
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item :active="true" active-class="test" to="/home">Accueil</b-nav-item>
          <b-nav-item active-class="" to="/planning">Mon planning</b-nav-item>
          <b-nav-item active-class="" to="/equipe">Mon équipe Vitalliance</b-nav-item>
          <b-nav-item active-class="" to="/documents">Mes documents</b-nav-item>
          <b-nav-item active-class="" to="/coordonnees">Mes coordonnées</b-nav-item>
       -->
        <b-nav-item
          v-for="(item, i) in navBarItems"
          :key="i"
          :active="currentRouteFullName == item.route"
          active-class="custom-active-class"
          :to="item.route"
          >{{ $t(item.name) }}</b-nav-item
        >

        <b-nav-item @click="_disconnect">
          <svgicon
            icon="logout"
            color="#000"
            height="24px"
            width="24px"
          ></svgicon>
        </b-nav-item>

        <!-- <b-nav-item-dropdown right>
            <template slot="button-content">
              <svgicon icon="user" color="#bbb"></svgicon>
              {{ fullNameClient }}
            </template>
            <b-dropdown-item to="/profil">Mon profil</b-dropdown-item>
            <b-dropdown-item >Déconnexion</b-dropdown-item>
          </b-nav-item-dropdown> -->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import notificationService from "../../services/notification";
import conditionHelper from "@/helpers/condition";

// Flag the navBar items with distrinct values to allow filtering
export default {
  data() {
    return {
      countContentConversationsInterval: undefined,
      fullNameClient: "",
      isShowChat: true,
      customerNavBarItems: [
        {
          name: "navbar-home",
          route: "/home"
        },
        {
          name: "c-planning-title",
          route: "/planning"
        },
        {
          name: "team-page-title",
          route: "/equipe"
        },
        {
          name: "documents-title",
          route: "/documents"
        },
        {
          multiConditions: [
            "rcfchatclientagency",
            "rcfchatadvteamclient",
            "rcfchatclient"
          ],
          name: "discussions-title",
          route: "/discussions"
        },
        // {
        //   name: "Télégestion",
        //   route: "/telegestion"
        // },
        {
          name: "contact-info-title",
          route: "/coordonnees"
        }
      ],
      navItems: [],
      sharedHousingNavBarItems: [
        {
          name: "c-navbar-home",
          route: "/home"
        },
        {
          name: "c-planning-title",
          route: "/planning"
        },
        {
          name: "team-page-title",
          route: "/equipe"
        }
      ],
      numberNotiInApp: 0,
      countNotificationsInterval: undefined
    };
  },
  computed: {
    ...mapGetters("chat", {
      numberUnreadConversations: "numberUnreadConversations",
      chatSettings: "chatSettings"
    }),
    ...mapState("auth", ["user"]),
    ...mapState("locale", ["locale"]),
    currentRouteFullName: function() {
      return this.$router.currentRoute.fullPath;
    },
    showNotification() {
      return conditionHelper("rcfnotificationclient");
    },
    navBarItems: function() {
      if (this.user.isSharedHousing) {
        return this.sharedHousingNavBarItems;
      } else {
        const conditions = JSON.parse(localStorage.getItem("conditions"));
        const menuItems = [];
        this.customerNavBarItems
          .filter(item => !item.hidden)
          .forEach(item => {
            if (item.key && conditions && conditions[item.key]) {
              menuItems.push(item);
            } else if (
              conditions &&
              item.multiConditions &&
              item.multiConditions.length
            ) {
              const conditionItem = item.multiConditions.find(
                condition => conditions[condition]
              );

              if (conditionItem) {
                menuItems.push(item);
                this.isShowChat = true;
              } else {
                this.isShowChat = false;
              }
            } else if (!item.key) {
              menuItems.push(item);
            }
          });
        return menuItems;
      }
    },
    ...mapGetters("notification", [
      "notifications",
      "unreadNotifs",
      "notificationConfig"
    ]),
    ...mapGetters("auth", {
      currentFrontendTech: "currentfrontendTech"
    })
  },
  async created() {
    let numberNotiInterval = 30000;
    this.getChatSettings();
    if (!this.notificationConfig) {
      this.getNotificationConfig();
      if (localStorage.getItem("notificationConfig")) {
        numberNotiInterval = JSON.parse(
          localStorage.getItem("notificationConfig")
        ).frequenceCallingCountNotifications
          ? JSON.parse(localStorage.getItem("notificationConfig"))
              .frequenceCallingCountNotifications * 1000
          : 30000;
      }
    } else {
      numberNotiInterval =
        this.notificationConfig &&
        this.notificationConfig.frequenceCallingCountNotifications
          ? this.notificationConfig.frequenceCallingCountNotifications * 1000
          : 30000;
    }

    this.getNumberNotiInApp();

    this.countNotificationsInterval = setInterval(() => {
      this.getNumberNotiInApp();
    }, numberNotiInterval);
    let numberUnreadMessageInterval =
      this.chatSettings && this.chatSettings.freqRefreshCountUnreadCons
        ? this.chatSettings.freqRefreshCountUnreadCons * 1000
        : 30000;

    this.getNumberUnreadConversation(this.user.pkClient);
    this.countContentConversationsInterval = setInterval(() => {
      this.getNumberUnreadConversation(this.user.pkClient);
    }, numberUnreadMessageInterval);
  },
  beforeDestroy() {
    clearInterval(this.countContentConversationsInterval);
    clearInterval(this.countNotificationsInterval);
  },
  methods: {
    ...mapActions("chat", ["getNumberUnreadConversation", "getChatSettings"]),
    ...mapActions("auth", ["disconnect"]),
    ...mapActions("notification", {
      getNotifications: "GET_NOTIFICATIONS",
      getNotificationConfig: "GET_NOTIFICATION_CONFIG"
    }),
    // ...mapActions(['changeLocale']),
    _disconnect() {
      this.disconnect(this.$route);
      this.$store.commit("profile/SET_DATA", null);
      this.$store.commit("profile/SET_CORRESPONDENT_ADDRESS", null);
      this.$store.commit("profile/SET_RELATED_PERSON", null);
      this.$store.commit("profile/SET_RECIPIENT_TYPES", null);
    },
    menuItems() {
      //const conditions = JSON.parse(localStorage.getItem("conditions"));
      /*if (this.user.isSharedHousing) {
        return this.sharedHousingNavBarItems;
      } else {*/
      /*const menuItems = [];
        this.customerNavBarItems.forEach(item => {
          if (item.key && conditions[item.key]) {
            menuItems.push(item);
          } else if (!item.key) {
            menuItems.push(item);
          }
        });
        this.navItems = menuItems;*/
      /*}*/
    },

    getNumberNotiInApp() {
      const param = {
        idPkUserType: 1,
        pkUser: this.user.pkCrf,
        keyFrontendTech: this.currentFrontendTech,
        isBackground: true
      };
      if (!this.currentFrontendTech) {
        notificationService.getFrontendTechs().then(result => {
          const currTokenOS = "Client";
          if (result) {
            const webTech = result.frontendTechs.find(
              item =>
                item.tokenMethod &&
                item.tokenMethod.labelTokenMethod &&
                item.tokenMethod.labelTokenMethod === currTokenOS &&
                item.isWebApp
            ).key;
            this.$store.commit("auth/UPDATE_CURRENT_FRONTEND_TECH", webTech);
            param.keyFrontendTech = webTech;
            notificationService.getNumberCountNotiInApp(param).then(res => {
              this.numberNotiInApp = res.nbNotificationUnread;
            });
          }
        });
      } else {
        notificationService.getNumberCountNotiInApp(param).then(res => {
          this.numberNotiInApp = res.nbNotificationUnread;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#header-navbar {
  position: sticky;
  @media screen and (max-width: 766px) {
    &.fixed-top {
      z-index: 2002 !important;
    }
  }
}

.custom-active-class {
  color: var(--primary) !important;
}

.num {
  position: absolute;
  /* font-size: 0.3em; */
  top: 5px;
  right: -6px;
  width: 20px;
  height: 20px;
  padding: 2px;
  font-size: 11px;
  border-radius: 50%;
  text-align: center;
  color: #fff;
  /* right: 2px; */
  background: #ec5f71;
}
.unread-number {
  width: 15px;
  height: 15px;
  background-color: #ec5f71;
  border-radius: 50%;
  color: white;
  top: 0;
  right: 0;
  font-size: 12px;
  text-align: center;
  line-height: 15px;
}

.discussion-icon {
  @media screen and (max-width: 394px) {
    margin-left: 0px !important;
    svg {
      width: 18px !important;
      height: 18px !important;
    }
  }
}

.vitalliance-icon {
  @media screen and (max-width: 394px) {
    margin-left: 0px !important;
    svg {
      width: 150px !important;
    }
  }

  @media screen and (max-width: 329px) {
    margin-left: 0px !important;
    svg {
      width: 140px !important;
    }
  }
}

.noti-icon {
  @media screen and (max-width: 394px) {
    margin-left: 0px !important;
    svg {
      width: 18px !important;
      height: 18px !important;
    }
  }
}
</style>
